module.exports = __webpack_public_path__ + "img/natura_2000.6a810109.jpg";